import { render } from "./continentList.vue?vue&type=template&id=0ed4edaa&scoped=true"
import script from "./continentList.vue?vue&type=script&lang=js"
export * from "./continentList.vue?vue&type=script&lang=js"

import "./continentList.vue?vue&type=style&index=0&id=0ed4edaa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ed4edaa"]])

export default __exports__